import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import { suppressionListsNroHeading, suppressionListsPageNameForTracking } from "../../suppressionListsNavCopy";

const EditSuppressionList = lazy(() =>
  import("@scenes/SuppressionLists/components/EditSuppressionList").then((module) => ({
    default: module.EditSuppressionList,
  }))
);

export const suppressionListsDetailsNRO: NavigationRoutingObject = {
  Component: EditSuppressionList,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "audience",
  heading: suppressionListsNroHeading,
  pageNameForTracking: suppressionListsPageNameForTracking,
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/suppression_lists/:appGroupId",
};
